import { Component, PropTypes, Children } from 'react';

class DataSet extends Component {
  constructor(props, context) {
    super(props, context);
    this.data = props.data;
  }

  getChildContext() {
    return {
      data: this.data,
    };
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}

DataSet.propTypes = {
  data: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
};

DataSet.childContextTypes = {
  data: PropTypes.object.isRequired,
};

export default DataSet;



// WEBPACK FOOTER //
// ./src/modules/common/containers/DataSet.js